import React, { Fragment, useEffect, useRef, useState } from "react";
import ColorPicker from "material-ui-color-picker";
import Loader from "../../common/Loader"
import { FONT_FAMILY } from '../../constant/bannerItems'
import DeleteIcon from '@material-ui/icons/Delete';
import { List, makeStyles, ListItem, ListItemText, ListItemSecondaryAction, TextField, Button, FormControl, Select, MenuItem, TextareaAutosize } from "@material-ui/core";
import JoditEditor from "jodit-react";
import TextEditorConfig from "../../helpers/TextEditor";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 600,
        backgroundColor: theme.palette.background.paper,
    },
    createUser: {
        width: '100%',
        maxWidth: 800,
    },
    textField: {
        width: '40ch',
    }
}));

const TestimonialForm = ({ testimonialId, handleFileInputChange, setImage, isLoading, handleClose, inputs, handleInputChange, handleColorPicker, resetColor, handleSubmit, errors, fromEditAction, deleteImage, avatar }) => {

    const classes = useStyles();
    const editor = useRef(null)
    const [temp, setTemp] = useState("")

    const errorClass = {
        color: "red",
    }

    const onSubmit = () => {
        handleSubmit()
    }


    return (
        <Fragment>
            {isLoading && (
                <Loader />
            )}
            {fromEditAction && (
                <div className="banner-form" style={{ 'minHeight': '52vh' }}
                >
                    <form className="banner-form-style" style={{ 'minWidth': '60rem' }}>
                        <List>
                            {fromEditAction === 'name' && (
                                <>
                                    <ListItem>
                                        <div className="row inputRow w-100">
                                            <div className="col-md-3 form-group">
                                                <ListItemText id="switch-list-label-wifi" primary="Name Font" />
                                            </div>
                                            <div className="col-md-9 form-group">
                                                <JoditEditor
                                                    ref={editor}
                                                    value={inputs.name}
                                                    config={TextEditorConfig}
                                                    tabIndex={1}
                                                    onChange={(bodyOfEditor) => {
                                                        inputs.name = bodyOfEditor
                                                        setTemp('0');
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </ListItem>

                                </>
                            )}
                            {fromEditAction === 'title' && (
                                <>
                                    <ListItem>
                                        <div className="row inputRow w-100">
                                            <div className="col-md-3 form-group">
                                                <ListItemText id="switch-list-label-wifi" primary="Title" />
                                            </div>
                                            <div className="col-md-9 form-group">
                                                <JoditEditor
                                                    ref={editor}
                                                    value={inputs.title}
                                                    config={TextEditorConfig}
                                                    tabIndex={1}
                                                    onChange={(bodyOfEditor) => {
                                                        inputs.title = bodyOfEditor
                                                        setTemp('0');
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </ListItem>

                                </>
                            )}
                            {fromEditAction === 'testimonial' && (
                                <>
                                    <ListItem>
                                        <div className="row inputRow w-100">
                                            <div className="col-md-3 form-group">
                                                <ListItemText id="switch-list-label-wifi" primary="Testimonial" />
                                            </div>
                                            <div className="col-md-9 form-group">
                                                <JoditEditor
                                                    ref={editor}
                                                    value={inputs.testimonial}
                                                    config={TextEditorConfig}
                                                    tabIndex={1}
                                                    onChange={(bodyOfEditor) => {
                                                        inputs.testimonial = bodyOfEditor
                                                        setTemp('0');
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </ListItem>
                                </>
                            )}


                            {fromEditAction === 'avatar' && (
                                <>

                                    <ListItem>
                                    <div className="row w-100">
                                        <div className="col-lg-3">
                                            <ListItemText id="switch-list-label-wifi" primary="Avatar" />
                                        </div>
                                        <div className="col-lg-9">
                                        <FormControl variant="outlined" className="w-100">
                                                <div className="uploadedImg">
                                                    <input onChange={handleFileInputChange}
                                                        type="file"
                                                        name="image"
                                                    />
                                                    {avatar != "" && avatar != 'undefined' && (
                                                        <>
                                                            <img height="50px" width="50px" src={avatar} className="mt-15"></img>
                                                            <DeleteIcon
                                                                className="text-error"
                                                                title={"Delete"}
                                                                onClick={() => {
                                                                    setImage("", 'avatar')
                                                                    deleteImage('avatar')
                                                                }}
                                                                aria-label=""
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            </FormControl>
                                        </div>
                                    </div>
                                </ListItem>
                                
                                <ListItem>
                                    <div className="row w-100 mb-4 mt-10">
                                        <div className="col-lg-3">
                                            <ListItemText id="switch-list-label-wifi" primary="Recommended Image Size" />
                                        </div>
                                        <div className="col-lg-9 mt-1">
                                            <p className="font-weight-bold h5" style={{fontFamily:'"Roboto", "Helvetica", "Arial", sans-serif;'}}>90 x 90</p>
                                        </div>
                                    </div>
                                </ListItem>

                                </>
                            )}

                            <ListItem>
                                <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                                <Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {testimonialId ? "Update" : "Save"}</Button>

                            </ListItem>
                        </List>

                    </form>
                </div>
            )}
        </Fragment>
    );
};

export default TestimonialForm;
